// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/models/credit/credit_factor.proto (package kikoff_canada.protobuf.models.credit, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ReportAccount } from "./report_account_pb.js";

/**
 * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor
 */
export class CreditFactor extends Message<CreditFactor> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.Grade grade = 2;
   */
  grade = CreditFactor.Grade.NA;

  /**
   * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.Impact impact = 3;
   */
  impact = CreditFactor.Impact.LOW;

  /**
   * @generated from field: string message = 4;
   */
  message = "";

  /**
   * @generated from oneof kikoff_canada.protobuf.models.credit.CreditFactor.details
   */
  details: {
    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.CardUsage card_usage = 5;
     */
    value: CreditFactor.CardUsage;
    case: "cardUsage";
  } | {
    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.PaymentHistory payment_history = 6;
     */
    value: CreditFactor.PaymentHistory;
    case: "paymentHistory";
  } | {
    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.CreditMix credit_mix = 7;
     */
    value: CreditFactor.CreditMix;
    case: "creditMix";
  } | {
    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks derogatory_marks = 8;
     */
    value: CreditFactor.DerogatoryMarks;
    case: "derogatoryMarks";
  } | {
    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.CreditAge credit_age = 9;
     */
    value: CreditFactor.CreditAge;
    case: "creditAge";
  } | {
    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.HardInquiries hard_inquiries = 10;
     */
    value: CreditFactor.HardInquiries;
    case: "hardInquiries";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: int32 factor_diff = 12;
   */
  factorDiff = 0;

  /**
   * @generated from field: int32 value = 13;
   */
  value = 0;

  /**
   * @generated from field: int32 factor_diff_time_delta_days = 14;
   */
  factorDiffTimeDeltaDays = 0;

  constructor(data?: PartialMessage<CreditFactor>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "grade", kind: "enum", T: proto3.getEnumType(CreditFactor.Grade) },
    { no: 3, name: "impact", kind: "enum", T: proto3.getEnumType(CreditFactor.Impact) },
    { no: 4, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "card_usage", kind: "message", T: CreditFactor.CardUsage, oneof: "details" },
    { no: 6, name: "payment_history", kind: "message", T: CreditFactor.PaymentHistory, oneof: "details" },
    { no: 7, name: "credit_mix", kind: "message", T: CreditFactor.CreditMix, oneof: "details" },
    { no: 8, name: "derogatory_marks", kind: "message", T: CreditFactor.DerogatoryMarks, oneof: "details" },
    { no: 9, name: "credit_age", kind: "message", T: CreditFactor.CreditAge, oneof: "details" },
    { no: 10, name: "hard_inquiries", kind: "message", T: CreditFactor.HardInquiries, oneof: "details" },
    { no: 12, name: "factor_diff", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "factor_diff_time_delta_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor {
    return new CreditFactor().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor {
    return new CreditFactor().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor {
    return new CreditFactor().fromJsonString(jsonString, options);
  }

  static equals(a: CreditFactor | PlainMessage<CreditFactor> | undefined, b: CreditFactor | PlainMessage<CreditFactor> | undefined): boolean {
    return proto3.util.equals(CreditFactor, a, b);
  }

  static _enums: {
    Grade: typeof CreditFactor.Grade,
    Impact: typeof CreditFactor.Impact,
  };
}

export namespace CreditFactor {
  /**
   * @generated from enum kikoff_canada.protobuf.models.credit.CreditFactor.Grade
   */
  export enum Grade {
    /**
     * @generated from enum value: NA = 0;
     */
    NA = 0,

    /**
     * @generated from enum value: A = 1;
     */
    A = 1,

    /**
     * @generated from enum value: B = 2;
     */
    B = 2,

    /**
     * @generated from enum value: C = 3;
     */
    C = 3,

    /**
     * @generated from enum value: D = 4;
     */
    D = 4,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreditFactor.Grade)
  proto3.util.setEnumType(CreditFactor.Grade, "kikoff_canada.protobuf.models.credit.CreditFactor.Grade", [
    { no: 0, name: "NA" },
    { no: 1, name: "A" },
    { no: 2, name: "B" },
    { no: 3, name: "C" },
    { no: 4, name: "D" },
  ]);
}

export namespace CreditFactor {
  /**
   * @generated from enum kikoff_canada.protobuf.models.credit.CreditFactor.Impact
   */
  export enum Impact {
    /**
     * @generated from enum value: LOW = 0;
     */
    LOW = 0,

    /**
     * @generated from enum value: MEDIUM = 1;
     */
    MEDIUM = 1,

    /**
     * @generated from enum value: HIGH = 2;
     */
    HIGH = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(CreditFactor.Impact)
  proto3.util.setEnumType(CreditFactor.Impact, "kikoff_canada.protobuf.models.credit.CreditFactor.Impact", [
    { no: 0, name: "LOW" },
    { no: 1, name: "MEDIUM" },
    { no: 2, name: "HIGH" },
  ]);
}

export namespace CreditFactor {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.CardUsage
   */
  export class CardUsage extends Message<CreditFactor.CardUsage> {
    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.CardUsage.Utilization kikoff_utilization = 1;
     */
    kikoffUtilization?: CreditFactor.CardUsage.Utilization;

    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.CreditFactor.CardUsage.Utilization total_utilization = 2;
     */
    totalUtilization?: CreditFactor.CardUsage.Utilization;

    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.ReportAccount.Preview accounts = 3;
     */
    accounts: ReportAccount.Preview[] = [];

    constructor(data?: PartialMessage<CreditFactor.CardUsage>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.CardUsage";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "kikoff_utilization", kind: "message", T: CreditFactor.CardUsage.Utilization },
      { no: 2, name: "total_utilization", kind: "message", T: CreditFactor.CardUsage.Utilization },
      { no: 3, name: "accounts", kind: "message", T: ReportAccount.Preview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.CardUsage {
      return new CreditFactor.CardUsage().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.CardUsage {
      return new CreditFactor.CardUsage().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.CardUsage {
      return new CreditFactor.CardUsage().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.CardUsage | PlainMessage<CreditFactor.CardUsage> | undefined, b: CreditFactor.CardUsage | PlainMessage<CreditFactor.CardUsage> | undefined): boolean {
      return proto3.util.equals(CreditFactor.CardUsage, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor.CardUsage {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.CardUsage.Utilization
   */
  export class Utilization extends Message<CreditFactor.CardUsage.Utilization> {
    /**
     * @generated from field: string name = 1;
     */
    name = "";

    /**
     * @generated from field: uint32 balance = 2;
     */
    balance = 0;

    /**
     * @generated from field: uint32 limit = 3;
     */
    limit = 0;

    constructor(data?: PartialMessage<CreditFactor.CardUsage.Utilization>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.CardUsage.Utilization";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "balance", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.CardUsage.Utilization {
      return new CreditFactor.CardUsage.Utilization().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.CardUsage.Utilization {
      return new CreditFactor.CardUsage.Utilization().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.CardUsage.Utilization {
      return new CreditFactor.CardUsage.Utilization().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.CardUsage.Utilization | PlainMessage<CreditFactor.CardUsage.Utilization> | undefined, b: CreditFactor.CardUsage.Utilization | PlainMessage<CreditFactor.CardUsage.Utilization> | undefined): boolean {
      return proto3.util.equals(CreditFactor.CardUsage.Utilization, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.PaymentHistory
   */
  export class PaymentHistory extends Message<CreditFactor.PaymentHistory> {
    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.ReportAccount.Preview accounts = 1;
     */
    accounts: ReportAccount.Preview[] = [];

    constructor(data?: PartialMessage<CreditFactor.PaymentHistory>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.PaymentHistory";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "accounts", kind: "message", T: ReportAccount.Preview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.PaymentHistory {
      return new CreditFactor.PaymentHistory().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.PaymentHistory {
      return new CreditFactor.PaymentHistory().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.PaymentHistory {
      return new CreditFactor.PaymentHistory().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.PaymentHistory | PlainMessage<CreditFactor.PaymentHistory> | undefined, b: CreditFactor.PaymentHistory | PlainMessage<CreditFactor.PaymentHistory> | undefined): boolean {
      return proto3.util.equals(CreditFactor.PaymentHistory, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.CreditMix
   */
  export class CreditMix extends Message<CreditFactor.CreditMix> {
    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.ReportAccount.Preview accounts = 1;
     */
    accounts: ReportAccount.Preview[] = [];

    constructor(data?: PartialMessage<CreditFactor.CreditMix>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.CreditMix";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "accounts", kind: "message", T: ReportAccount.Preview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.CreditMix {
      return new CreditFactor.CreditMix().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.CreditMix {
      return new CreditFactor.CreditMix().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.CreditMix {
      return new CreditFactor.CreditMix().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.CreditMix | PlainMessage<CreditFactor.CreditMix> | undefined, b: CreditFactor.CreditMix | PlainMessage<CreditFactor.CreditMix> | undefined): boolean {
      return proto3.util.equals(CreditFactor.CreditMix, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks
   */
  export class DerogatoryMarks extends Message<CreditFactor.DerogatoryMarks> {
    /**
     * we should deprecate this
     *
     * @generated from field: uint32 collections_count = 1;
     */
    collectionsCount = 0;

    /**
     * @generated from field: uint32 public_records_count = 2;
     */
    publicRecordsCount = 0;

    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.ReportAccount.Preview accounts = 3;
     */
    accounts: ReportAccount.Preview[] = [];

    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks.Collection collections = 4;
     */
    collections: CreditFactor.DerogatoryMarks.Collection[] = [];

    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks.Judgement judgements = 5;
     */
    judgements: CreditFactor.DerogatoryMarks.Judgement[] = [];

    constructor(data?: PartialMessage<CreditFactor.DerogatoryMarks>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "collections_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 2, name: "public_records_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "accounts", kind: "message", T: ReportAccount.Preview, repeated: true },
      { no: 4, name: "collections", kind: "message", T: CreditFactor.DerogatoryMarks.Collection, repeated: true },
      { no: 5, name: "judgements", kind: "message", T: CreditFactor.DerogatoryMarks.Judgement, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.DerogatoryMarks {
      return new CreditFactor.DerogatoryMarks().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.DerogatoryMarks {
      return new CreditFactor.DerogatoryMarks().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.DerogatoryMarks {
      return new CreditFactor.DerogatoryMarks().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.DerogatoryMarks | PlainMessage<CreditFactor.DerogatoryMarks> | undefined, b: CreditFactor.DerogatoryMarks | PlainMessage<CreditFactor.DerogatoryMarks> | undefined): boolean {
      return proto3.util.equals(CreditFactor.DerogatoryMarks, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor.DerogatoryMarks {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks.Collection
   */
  export class Collection extends Message<CreditFactor.DerogatoryMarks.Collection> {
    /**
     * @generated from field: string creditor = 1;
     */
    creditor = "";

    /**
     * @generated from field: uint32 current_balance_cents = 2;
     */
    currentBalanceCents = 0;

    constructor(data?: PartialMessage<CreditFactor.DerogatoryMarks.Collection>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks.Collection";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "creditor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "current_balance_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.DerogatoryMarks.Collection {
      return new CreditFactor.DerogatoryMarks.Collection().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.DerogatoryMarks.Collection {
      return new CreditFactor.DerogatoryMarks.Collection().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.DerogatoryMarks.Collection {
      return new CreditFactor.DerogatoryMarks.Collection().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.DerogatoryMarks.Collection | PlainMessage<CreditFactor.DerogatoryMarks.Collection> | undefined, b: CreditFactor.DerogatoryMarks.Collection | PlainMessage<CreditFactor.DerogatoryMarks.Collection> | undefined): boolean {
      return proto3.util.equals(CreditFactor.DerogatoryMarks.Collection, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor.DerogatoryMarks {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks.Judgement
   */
  export class Judgement extends Message<CreditFactor.DerogatoryMarks.Judgement> {
    /**
     * @generated from field: string plaintiff = 1;
     */
    plaintiff = "";

    /**
     * @generated from field: uint32 amount_cents = 2;
     */
    amountCents = 0;

    constructor(data?: PartialMessage<CreditFactor.DerogatoryMarks.Judgement>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.DerogatoryMarks.Judgement";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "plaintiff", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "amount_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.DerogatoryMarks.Judgement {
      return new CreditFactor.DerogatoryMarks.Judgement().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.DerogatoryMarks.Judgement {
      return new CreditFactor.DerogatoryMarks.Judgement().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.DerogatoryMarks.Judgement {
      return new CreditFactor.DerogatoryMarks.Judgement().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.DerogatoryMarks.Judgement | PlainMessage<CreditFactor.DerogatoryMarks.Judgement> | undefined, b: CreditFactor.DerogatoryMarks.Judgement | PlainMessage<CreditFactor.DerogatoryMarks.Judgement> | undefined): boolean {
      return proto3.util.equals(CreditFactor.DerogatoryMarks.Judgement, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.CreditAge
   */
  export class CreditAge extends Message<CreditFactor.CreditAge> {
    /**
     * @generated from field: uint32 oldest_age_months = 1;
     */
    oldestAgeMonths = 0;

    /**
     * @generated from field: uint32 average_age_months = 2;
     */
    averageAgeMonths = 0;

    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.ReportAccount.Preview accounts = 3;
     */
    accounts: ReportAccount.Preview[] = [];

    constructor(data?: PartialMessage<CreditFactor.CreditAge>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.CreditAge";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "oldest_age_months", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 2, name: "average_age_months", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 3, name: "accounts", kind: "message", T: ReportAccount.Preview, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.CreditAge {
      return new CreditFactor.CreditAge().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.CreditAge {
      return new CreditFactor.CreditAge().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.CreditAge {
      return new CreditFactor.CreditAge().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.CreditAge | PlainMessage<CreditFactor.CreditAge> | undefined, b: CreditFactor.CreditAge | PlainMessage<CreditFactor.CreditAge> | undefined): boolean {
      return proto3.util.equals(CreditFactor.CreditAge, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.HardInquiries
   */
  export class HardInquiries extends Message<CreditFactor.HardInquiries> {
    /**
     * @generated from field: uint32 hard_inquiries_count = 1;
     */
    hardInquiriesCount = 0;

    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.CreditFactor.HardInquiries.Inquiry inquiries = 2;
     */
    inquiries: CreditFactor.HardInquiries.Inquiry[] = [];

    constructor(data?: PartialMessage<CreditFactor.HardInquiries>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.HardInquiries";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "hard_inquiries_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
      { no: 2, name: "inquiries", kind: "message", T: CreditFactor.HardInquiries.Inquiry, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.HardInquiries {
      return new CreditFactor.HardInquiries().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.HardInquiries {
      return new CreditFactor.HardInquiries().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.HardInquiries {
      return new CreditFactor.HardInquiries().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.HardInquiries | PlainMessage<CreditFactor.HardInquiries> | undefined, b: CreditFactor.HardInquiries | PlainMessage<CreditFactor.HardInquiries> | undefined): boolean {
      return proto3.util.equals(CreditFactor.HardInquiries, a, b);
    }

    static _enums: {
    };
  }
}

export namespace CreditFactor.HardInquiries {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.CreditFactor.HardInquiries.Inquiry
   */
  export class Inquiry extends Message<CreditFactor.HardInquiries.Inquiry> {
    /**
     * @generated from field: string contact_name = 1;
     */
    contactName = "";

    /**
     * @generated from field: google.protobuf.Timestamp date = 2;
     */
    date?: Timestamp;

    constructor(data?: PartialMessage<CreditFactor.HardInquiries.Inquiry>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.CreditFactor.HardInquiries.Inquiry";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "contact_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "date", kind: "message", T: Timestamp },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreditFactor.HardInquiries.Inquiry {
      return new CreditFactor.HardInquiries.Inquiry().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreditFactor.HardInquiries.Inquiry {
      return new CreditFactor.HardInquiries.Inquiry().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreditFactor.HardInquiries.Inquiry {
      return new CreditFactor.HardInquiries.Inquiry().fromJsonString(jsonString, options);
    }

    static equals(a: CreditFactor.HardInquiries.Inquiry | PlainMessage<CreditFactor.HardInquiries.Inquiry> | undefined, b: CreditFactor.HardInquiries.Inquiry | PlainMessage<CreditFactor.HardInquiries.Inquiry> | undefined): boolean {
      return proto3.util.equals(CreditFactor.HardInquiries.Inquiry, a, b);
    }

    static _enums: {
    };
  }
}

